import { render, staticRenderFns } from "./FilteredPostsList.vue?vue&type=template&id=8406c5bc"
import script from "./FilteredPostsList.vue?vue&type=script&lang=js"
export * from "./FilteredPostsList.vue?vue&type=script&lang=js"
import style0 from "./FilteredPostsList.vue?vue&type=style&index=0&id=8406c5bc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports